'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'bullseye-pointer';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f649';
var svgPathData = 'M464 256c0 114.9-93.1 208-208 208-4.2 0-8.3-.1-12.4-.4l-6.9 20.6c-3.4 10.3-8.9 18.8-15.6 25.4 11.4 1.6 23 2.4 34.9 2.4 141.4 0 256-114.6 256-256S397.4 0 256 0 0 114.6 0 256c0 11.8 .8 23.5 2.4 34.9 6.6-6.7 15.1-12.1 25.4-15.6l20.6-6.9c-.2-4.1-.4-8.2-.4-12.4 0-114.9 93.1-208 208-208s208 93.1 208 208zm-64 0c0-79.5-64.5-144-144-144-76.5 0-139.1 59.7-143.7 135.1L163.6 230c11.3-40.4 48.4-70 92.4-70 53 0 96 43 96 96 0 44-29.6 81.1-70 92.4l-17.1 51.3C340.3 395.1 400 332.5 400 256zM255.2 277.1c1.9-5.8 .4-12.1-3.9-16.4s-10.6-5.8-16.4-3.9l-192 64C36.4 323 32 329.1 32 336s4.4 13 10.9 15.2l63 21-90.9 90.9c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l90.9-90.9 21 63c2.2 6.5 8.3 10.9 15.2 10.9s13-4.4 15.2-10.9l64-192z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBullseyePointer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;